import * as LoggedInUserInformationActions from './loggedinuser-information.actions';
import { LoggedInUserInformation } from './loggedinuser-information.model';

export interface State {
    loggedInUserInformation: LoggedInUserInformation;
}

const initialState: State = {
    loggedInUserInformation: {
        BloodGroup: '',
        BloodGroupId: 0,
        DateOfBirth: '',
        DateOfJoining: '',
        DepartmentId: 0,
        DepartmentName: '',
        Designation: '',
        DesignationId: 0,
        DisplayTitle: '',
        EmergencyContactNo: '',
        EmployeeJobTitleId: 0,
        Gender: '',
        GenderId: '',
        LocationId: 0,
        LocationName: '',
        LoginTitle: '',
        MaritalStatus: '',
        MaritalStatusId: 0,
        MenuId: 0,
        MobileNumber: '',
        OrgId: 0,
        PersonalEmail: '',
        RoleId: 0,
        ScreenID: 0,
        UserFullName: '',
        UserId: 0,
        UserPhoto: '',
        UserSourceId: 0,
        UserSourceTypeId: 0
    }
};

export function loggedInUserInformationReducer(state = initialState, action: LoggedInUserInformationActions.LoggedInUserInformationActions) {
    switch (action.type) {
        case (LoggedInUserInformationActions.Add_LoggedInUserInformation):

            const updatedLoggedInUserInformation = action.payload;


            let updatedLoggedInUserInfo = state.loggedInUserInformation;
            updatedLoggedInUserInfo = updatedLoggedInUserInformation;

            return {
                ...state,
                loggedInUserInformation: updatedLoggedInUserInfo
            };

        default:
            return state;
    }
}
